import React from 'react'

interface BackgroundProps {
  children: React.ReactNode
}

const Background = ({ children }: BackgroundProps) => {
  return (
    <div className="relative w-full min-h-screen bg-[#F7F9FF] overflow-hidden">
      <div className="absolute left-[14.95%] right-[14.9%] top-[18.75%] bottom-[20.7%] opacity-85"></div>
      <div className="absolute h-[436px] left-[14.95%] right-[62.76%] top-[285px] bg-[#51E5FF] blur-[400px]"></div>
      <div className="absolute h-[436px] left-[62.8%] right-[14.9%] top-[285px] bg-[#DB5461] blur-[400px]"></div>
      <div className="absolute h-[620px] left-[37.24%] right-[38.03%] top-[192px] bg-[#354297] blur-[400px]"></div>
      <div className="absolute invisible h-[200px] left-[35.62%] right-[35.62%] top-0 bg-white"></div>
      <div className="relative z-10">{children}</div>
    </div>
  )
}

export default Background
